import { useEffect, useState } from 'react';

export function OfflineBanner(): JSX.Element | null {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const on = (): void => setOnline(true);
    const off = (): void => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 inset-x-0 z-50 bg-warning text-white text-center text-sm py-2 shadow-lg"
    >
      You're offline. Cached views still work; new orders and payments will retry when you
      reconnect.
    </div>
  );
}
